/* eslint-disable @nice-cxone/ccf/required-tsdoc */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Box, IconButton } from '@mui/material';
import styles from './simulator-v2-interaction-history-tab.module.scss';
import { getApplicationLocale } from '@nice-ccf/ui-components';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  CcfDatePickerIcon,
  CcfTextField,
  CcfBox,
  CcfTypography,
  CcfButton,
} from '@nice-ccf/ui-controls';
import CloseIcon from '@mui/icons-material/Close';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DropDown } from '../../../simulator/simulator';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 411,
  bgcolor: 'background.paper',
  boxShadow: 0,
  p: 4,
  borderRadius: 2,
  Height: 790,
};
const DatePickerIcon = () => {
  return (
    <CcfBox sx={{ display: 'flex' }}>
      <CcfDatePickerIcon />
    </CcfBox>
  );
};

const SimulatorV2InteractionHistoryModal: React.FC<{
  isOpen: boolean;
  handleClose: () => void;
  modalHeader: string;
  modalData: any;
  modalDataType: string;
  customerData: any;
  onCustomerDataSave: (data: any) => void;
  onSave: (data: any, type: string) => void;
}> = ({
  isOpen,
  handleClose,
  modalHeader,
  modalData,
  modalDataType,
  customerData,
  onCustomerDataSave,
  onSave,
}) => {
  const initialObject = {
    media: 'Email',
    date: dayjs(new Date()).toISOString(),
    status: 'open',
    contactTrackingId: '',
    contactRequest: '',
    agentName: '',
    endTime: '',
    skill: '',
    campaign: '',
    disposition: '',
    autoSummary: '',
    interactionId: parseInt(modalData.length + 1, 10) || 1,
  };
  const [modifiedModalData, setModifiedModalData] = useState(
    modalData && modalData[0] && modalDataType === 'new'
      ? initialObject
      : modalData
  );
  const [modifiedCustomerData, setModifiedCustomerData] =
    useState(customerData);
  const [error, setError] = useState(false);
  const [validate, setValidate] = useState(false);
  const [isInputValid, setIsInputValid] = useState<boolean>(true);
  // const handleValidation = () => {
  //   const isValid = validateInput(
  //     modifiedModalData?.media,
  //     modifiedModalData?.media === 'Email'
  //       ? modifiedCustomerData?.emailId
  //       : modifiedCustomerData?.phoneNo
  //   );
  //   setIsInputValid(isValid);
  // };
  const handleKeypress = (event: any) => {
    const { name, value } = event.target;
    if (name === 'emailId' || name === 'phoneNo') {
      setValidate(true);
    }
  };
  const handleInputChangeForHistory = (
    id: string,
    field: string,
    value: string | number | Dayjs
  ) => {
    setModifiedModalData((prevData: any) => ({
      ...prevData,
      [field]: value,
    }));
  };
  const locale = useSelector(getApplicationLocale);
  const handleChange = (event: any) => {
    const { name, value } = event.target;
    handleKeypress(event);
    setModifiedModalData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const validateInput = (media: string, value: string) => {
    if (media === 'Email') {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    } else if (media === 'Phone') {
      return /^\d{10}$/.test(value);
    }
    return false;
  };

  const handleContactChange = (event: any) => {
    const { name, value } = event.target;
    handleKeypress(event);
    setModifiedCustomerData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSave = () => {
    setValidate(true);
    if (
      !(modifiedModalData?.media === 'Email'
        ? modifiedCustomerData?.emailId
        : modifiedCustomerData?.phoneNo)
    ) {
      setError(true);
    } else {
      onSave(modifiedModalData, modalDataType);
      onCustomerDataSave(modifiedCustomerData);
      handleClose();
    }
  };
  const handleCloseError = () => {
    setError(false);
  };
  const handleInputChange = (field: string, value: any) => {
    setModifiedModalData((prevData: any) => ({
      ...prevData,
      [field]: value,
    }));
  };
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby={`${modalDataType}-modal-title`}
      aria-describedby={`${modalDataType}-modal-description`}
      slotProps={{
        backdrop: {
          style: {
            backgroundColor:
              modalDataType === 'edit'
                ? 'rgba(0, 0, 0, 0.3)'
                : 'rgba(0, 0, 0, 0.8)',
            opacity: modalDataType === 'edit' ? 0.3 : 0.8,
          },
        },
      }}
    >
      <Box sx={style}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingBottom: '16px',
          }}
        >
          <div
            className={styles.modalHeader}
            id="modal-modal-title"
            aria-label="modal-modal-title"
          >
            {modalHeader}
          </div>
          <IconButton
            onClick={handleClose}
            aria-label="close"
            sx={{
              width: 20,
              height: 20,
            }}
          >
            <CloseIcon
              sx={{
                fontSize: 20,
              }}
            />
          </IconButton>
        </Box>
        <div
          id="modal-description"
          aria-label="modal-description"
          className={styles.modalBody}
        >
          <CcfBox className={styles.containerGrid}>
            <CcfTypography className={styles.inputLabel}>CHANNEL</CcfTypography>
            <DropDown
              {...{
                currentValue: modifiedModalData?.media || '',
                field: 'media',
                label: '',
                name: 'media',
                options: [
                  'Email',
                  'Voice',
                  'SMS',
                  'Chat',
                  'Instagram',
                  'X',
                  'LinkedIn',
                  'Facebook',
                ],
                handleInputChange,
                id: `sm_interactionHistory_media_${modifiedModalData?.media}`,
                stackName: 'interactionHistory_media',
                selectInputStyle: {
                  borderRadius: '4px', // Example: Rounded corners
                  border: '1px solid #c4c4c4', // Example: Blue border
                  height: '36px', // Example: Adjust height
                  width: '20rem', // Example: Full width
                },
                selectRootStyle: {
                  padding: '10px', // Example: Adjust padding
                  fontSize: '1rem', // Example: Adjust font size
                },
              }}
            />
          </CcfBox>
          <CcfBox className={styles.containerGrid}>
            <CcfTypography className={styles.inputLabel}>DATE</CcfTypography>
            <LocalizationProvider
              adapterLocale={locale}
              dateAdapter={AdapterDayjs}
            >
              <DateTimePicker
                value={
                  modifiedModalData.date ? dayjs(modifiedModalData.date) : null
                }
                onChange={(newValue: any) =>
                  handleInputChangeForHistory(
                    modifiedModalData.id,
                    'date',
                    newValue ? newValue.toISOString() : null
                  )
                }
                renderInput={(props: any) => (
                  <CcfTextField
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '4px',
                        height: '36px',
                        border: '1px solid #AFC1CE',
                      },
                    }}
                    variant="outlined"
                    color="primary"
                    name="date"
                    InputLabelProps={{ shrink: true }}
                    {...props}
                  />
                )}
                components={{
                  OpenPickerIcon: DatePickerIcon,
                }}
              />
            </LocalizationProvider>
          </CcfBox>
          <CcfBox className={styles.containerGrid}>
            <CcfTypography className={styles.inputLabel}>STATUS</CcfTypography>
            <DropDown
              {...{
                currentValue: modifiedModalData?.status || '',
                field: 'status',
                label: '',
                options: ['open', 'closed'],
                handleInputChange,
                name: 'status',
                id: `sm_interactionHistory_status_${modifiedModalData?.status}`,
                stackName: 'interactionHistory_status',
                selectInputStyle: {
                  borderRadius: '4px', // Example: Rounded corners
                  border: '1px solid #c4c4c4', // Example: Blue border
                  height: '36px', // Example: Adjust height
                  width: '20rem', // Example: Full width
                },
                selectRootStyle: {
                  padding: '10px', // Example: Adjust padding
                  fontSize: '1rem', // Example: Adjust font size
                },
              }}
            />
          </CcfBox>
          <CcfBox className={styles.containerGrid}>
            <CcfTypography className={styles.inputLabel}>
              TRACKING ID {<span style={{ color: '#C2041A' }}>*</span>}
            </CcfTypography>
            <CcfTextField
              id="outlined-basic"
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '4px',
                  height: '36px',
                  border: '1px solid #AFC1CE',
                },
              }}
              fullWidth
              className={styles.padding_bottom}
              name="contactTrackingId"
              value={modifiedModalData?.contactTrackingId}
              onChange={handleChange}
            />
          </CcfBox>
          <CcfBox className={styles.containerGrid}>
            <CcfTypography className={styles.inputLabel}>
              CONTACT REQUEST {<span style={{ color: '#C2041A' }}>*</span>}
            </CcfTypography>
            <CcfTextField
              id="outlined-basic"
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '4px',
                  height: '36px',
                  border: '1px solid #AFC1CE',
                },
              }}
              fullWidth
              className={styles.padding_bottom}
              name="contactRequest"
              value={modifiedModalData?.contactRequest}
              onChange={handleChange}
            />
          </CcfBox>
          <CcfBox className={styles.containerGrid}>
            <CcfTypography className={styles.inputLabel}>
              AGENT NAME {<span style={{ color: '#C2041A' }}>*</span>}
            </CcfTypography>
            <CcfTextField
              id="outlined-basic"
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '4px',
                  height: '36px',
                  border: '1px solid #AFC1CE',
                },
              }}
              fullWidth
              className={styles.padding_bottom}
              name="agentName"
              value={modifiedModalData?.agentName}
              onChange={handleChange}
            />
          </CcfBox>
          <CcfBox className={styles.containerGrid}>
            <CcfTypography className={styles.inputLabel}>
              END TIME {<span style={{ color: '#C2041A' }}>*</span>}
            </CcfTypography>
            <CcfTextField
              id="outlined-basic"
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '4px',
                  height: '36px',
                  border: '1px solid #AFC1CE',
                },
              }}
              placeholder="HH:mm:ss (24-hour format) AM/PM"
              fullWidth
              className={styles.padding_bottom}
              name="endTime"
              value={modifiedModalData?.endTime}
              onChange={handleChange}
            />
          </CcfBox>
          <CcfBox className={styles.containerGrid}>
            <CcfTypography className={styles.inputLabel}>
              SKILL {<span style={{ color: '#C2041A' }}>*</span>}
            </CcfTypography>
            <CcfTextField
              id="outlined-basic"
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '4px',
                  height: '36px',
                  border: '1px solid #AFC1CE',
                },
              }}
              fullWidth
              className={styles.padding_bottom}
              name="skill"
              value={modifiedModalData?.skill}
              onChange={handleChange}
            />
          </CcfBox>
          <CcfBox className={styles.containerGrid}>
            <CcfTypography className={styles.inputLabel}>
              CAMPAIGN {<span style={{ color: '#C2041A' }}>*</span>}
            </CcfTypography>
            <CcfTextField
              id="outlined-basic"
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '4px',
                  height: '36px',
                  border: '1px solid #AFC1CE',
                },
              }}
              fullWidth
              className={styles.padding_bottom}
              name="campaign"
              value={modifiedModalData?.campaign}
              onChange={handleChange}
            />
          </CcfBox>
          <CcfBox className={styles.containerGrid}>
            <CcfTypography className={styles.inputLabel}>
              DISPOSITION {<span style={{ color: '#C2041A' }}>*</span>}
            </CcfTypography>
            <CcfTextField
              id="outlined-basic"
              variant="outlined"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '4px',
                  height: '36px',
                  border: '1px solid #AFC1CE',
                },
              }}
              fullWidth
              className={styles.padding_bottom}
              name="disposition"
              value={modifiedModalData?.disposition}
              onChange={handleChange}
            />
          </CcfBox>
          <CcfBox className={styles.containerGrid}>
            <CcfTypography className={styles.inputLabel}>
              AUTO SUMMARY {<span style={{ color: '#C2041A' }}>*</span>}
            </CcfTypography>
            <textarea
              id="outlined-basic"
              rows={4}
              className={styles.padding_bottom}
              name="autoSummary"
              value={modifiedModalData?.autoSummary}
              onChange={handleChange}
            />
          </CcfBox>
        </div>
        <div className={styles.modalFooter}>
          <CcfButton onClick={handleClose}>Cancel</CcfButton>
          <CcfButton
            onClick={handleSave}
            primary
            disabled={Object.values(modifiedModalData).some(
              (x: any) => x === ''
            )}
          >
            Save
          </CcfButton>
        </div>
      </Box>
    </Modal>
  );
};

export default SimulatorV2InteractionHistoryModal;
